import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './VaccineCalculator.css';


const VaccineCalculator = () => {
  const [birds, setBirds] = useState(100);
  const [birdsType, setBirdsType] = useState('');
  const [activeTab, setActiveTab] = useState('vaccine');

  const calculateVaccine = () => {
    setActiveTab('vaccine-result');
  };

  const handleBack = () => {
    setActiveTab('vaccine');
  };

  return (
    <>
    <Navbar />
    <div className="space-calculator-container">
      {/* Header */}
      <div>
        <div className="calculator-header">
           <img src="/assets/syringe.png" alt="syringe"/>
           <h1>Vaccine Calculator</h1>
        </div>

        {/* Tabs */}
        <div className='vaccine-calculator-tabs-container'>
            <p>
              Estimate how much of any type of  vaccine you need for your poultry birds.
            </p>
        </div>
      </div>

      <div>
        {/* SPB Calculator*/}
        {activeTab === 'vaccine' && (
          <div className="vaccine-calculator-card">
            <div>

                {/* Bird Count Input */}
                <div className="input-container">
                  <select
                    id="bird-type"
                    value={birdsType}
                    onChange={(e) => setBirdsType(e.target.value)}
                  >
                    <option value={''}>Select Poultry Type</option>
                  </select>
                </div>

                <div className="input-container">
                  <select
                    id="bird-type"
                    value={birdsType}
                    onChange={(e) => setBirdsType(e.target.value)}
                  >
                    <option value={''}>Select Vaccine</option>
                  </select>
                </div>

                <div className="input-container">
                <label htmlFor="bird-count">How many birds are you calculating for?</label>
                <input
                    type="number"
                    id="bird-count"
                    value={birds}
                    onChange={(e) => setBirds(e.target.value)}
                />
                </div>

                {/* Calculate Button */}
                <button className="calculate-btn" onClick={calculateVaccine}>
                Calculate
                </button>
            </div>
          </div>
        )}

        {activeTab === 'vaccine-result' && (
        <div className="egg-result-container">
          {/* Header */}
          <header className="egg-result-header">
            <img src="/assets/form-next.png" alt="next arrow" className="back-button" onClick={handleBack}/>
            <h1>Vaccine Result</h1>
          </header>

          {/* Chicken Details */}
          <div className="vaccine-card">
            <div className="vaccine-card-header">
              <div className='icon-wrapper-container'>
                <div className="icon-wrapper">
                  <img src="/assets/chicken.png" alt="Chicken Icon" />
                </div>
                <h2>100 Chicken</h2>
              </div>
              <button className="vaccine-edit-button">Edit</button>
            </div>
          </div>

          {/* egg Estimate */}
          <div className="card egg-estimate-card">
            <div className="egg-title-header">
              <img src="/assets/vaccine_estimate_icon.png" alt="vaccine Icon" style={{width: '30px', height: '30px'}}/>
              <h2>Vaccine Estimate</h2>
            </div>
            
            <p className='vaccine-item-title'>1st New Castle Disease Vaccine</p>

            <div className='result-container'>
              <p className='vaccine-item-subtitle'>Total Volume</p>
              <p className='vaccine-item-subtitle'>500ml (10 viral)</p>
            </div>
            <div className='result-container'>
              <p className='vaccine-item-subtitle'>Dosage</p>
              <p className='vaccine-item-subtitle'>5ml/Bird</p>
            </div>
          </div>

          {/* Actions */}
          <div className="vaccine-actions">
            <div className='action-btn-container'>
              <img src="/assets/mdi_share.png" alt="share icon" style={{width: '30px', height: '30px'}}/>
              <button className="action-button">Share</button>
            </div>
            <div className='action-btn-container'>
              <img src="/assets/download-outline.png" alt="download icon" style={{width: '24px', height: '24px'}}/>
              <button className="action-button">Download</button>
            </div>
          </div>
        </div>
        )}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default VaccineCalculator;
